var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#454A67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51682 4.19287C5.9001 3.72985 5 4.15283 5 4.90566V11.0943C5 11.8472 5.9001 12.2701 6.51682 11.8071L10.6384 8.71279C11.1205 8.35087 11.1205 7.64913 10.6384 7.28721L6.51682 4.19287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconRounded);
export default __webpack_public_path__ + "static/media/playIconRounded.c13bf107336ff00789adeedd3c1c3ee9.svg";
export { ForwardRef as ReactComponent };